import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { APIRequest } from '../../../common/Common';
import { getTotal } from '../../../common/Util';
import { TARGET_YEAR_API } from '../../../common/data';
// import { filterNonItemList } from './util';

const initialState = {
  isRender: false,
  reload: -1,
  dataList: [],
  //공제 불가 항목
  nonItemList: [],
  //원본데이터
  originalDataList: [],

  // 합계
  total: 0,
  //보험료 상세
  educationDetail: {},

  selectedEducationDetail: {},
};

//교육비 불러오기
export const getEducationInfo = createAsyncThunk('education/getEducationInfo', async () => {
  const response = await APIRequest(`/${TARGET_YEAR_API}/S7`);
  return response;
});

//교육비 저장
export const updateEducationInfo = createAsyncThunk('education/updateEducationInfo', async data => {
  const response = await APIRequest(`/${TARGET_YEAR_API}/S7AE`, data);
  return response;
});

//교육비 상세 불러오기
export const getEducationDetail = createAsyncThunk('education/getEducationDetail', async data => {
  const response = await APIRequest(`/${TARGET_YEAR_API}/S7`, data);
  return response;
});

const educationSlice = createSlice({
  name: 'educationSlice',
  initialState,
  reducers: {
    confirmDelete: (state, action) => {
      const { index } = action.payload;
      state.dataList = state.dataList.filter((_, idx) => idx !== index);
    },
    setSelectedEducationDetail: (state, action) => {
      state.selectedEducationDetail = action.payload;
    },
    setReload: (state, action) => {
      state.reload = Math.random();
    },
    // resetInsuranceState: state => {
    //   return {
    //     ...initialState,
    //     selectedInsuranceDetail: state.selectedInsuranceDetail,
    //   };
    // },
    resetEducationState: () => initialState,
  },
  extraReducers: builder => {
    builder.addCase(getEducationInfo.pending, state => {
      // state.dataList = [];
      // state.nonItemList = [];
      state.isRender = false;
    });
    builder.addCase(getEducationInfo.fulfilled, (state, action) => {
      console.log('교육비 리스트 >>', action.payload);
      const { list } = action.payload;
      if (list) {
        state.dataList = list;

        let totalList = list.filter(item => {
          return item.deType == '1';
        });
        state.total = getTotal(totalList, [
          'htm023',
          'htm072',
          'htm024',
          'htm073',
          'htm110',
          'htm111',
        ]);
      }
      state.isRender = true;
    });

    builder.addCase(updateEducationInfo.fulfilled, (state, action) => {
      console.log('교육비 저장 성공 >>', action.payload);
      const { resultCode } = action.payload;
      if (resultCode === 'OK') {
        state.reload = Math.random();
      }
    });

    builder.addCase(getEducationDetail.fulfilled, (state, action) => {
      console.log('교육비 상세 성공 >>', action.payload);
      const { list } = action.payload;
      if (list && list.length > 0) {
        let htm015 = list[0].htm015;
        //장애인아닌데 장애인코드 선택되어 있으면 초기화
        if (list[0].htm004 != '1' && list[0].htm015 == '5') htm015 = '';
        state.educationDetail = {
          ...list[0],
          htm015: htm015 || '', //코드
          htm023: list[0].htm023 || 0, //국세청 - 일반
          htm072: list[0].htm072 || 0, //국세청 - 교복비
          htm110: list[0].htm110 || 0, //국세청 - 현장학습비
          htm024: list[0].htm024 || 0, //국세청 - 일반
          htm073: list[0].htm073 || 0, //국세청 - 교복비
          htm111: list[0].htm111 || 0, //국세청 - 현장학습비
          htm151: list[0].htm151 || 0, //공제제외금액
        };
      } else {
        state.educationDetail = {};
      }
    });
  },
});

export const { confirmDelete, resetEducationState, setSelectedEducationDetail, setReload } =
  educationSlice.actions;
export default educationSlice.reducer;
